import axios from './../../config/axios';

export function getWarehouses(params) {
    return axios().get(`/stock-journal/warehouse`, { params })
}

export function getWarehouse({id}) {
    return axios().get(`/stock-journal/warehouse/${id}`);
}

export function search(query, limit = 10) {
    return axios().get(`/stock-journal/warehouse-search`, { params: {
        search: query,
        limit: limit
    }})
}

export default {
    getWarehouse,
    getWarehouses,
    search
}